"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isIRParentTerm = void 0;
var IRApp_1 = require("../IRNodes/IRApp.js");
var IRCase_1 = require("../IRNodes/IRCase.js");
var IRConstr_1 = require("../IRNodes/IRConstr.js");
var IRDelayed_1 = require("../IRNodes/IRDelayed.js");
var IRForced_1 = require("../IRNodes/IRForced.js");
var IRFunc_1 = require("../IRNodes/IRFunc.js");
var IRHoisted_1 = require("../IRNodes/IRHoisted.js");
var IRLetted_1 = require("../IRNodes/IRLetted.js");
function isIRParentTerm(stuff) {
    return (
    // stuff instanceof IRVar      ||
    stuff instanceof IRFunc_1.IRFunc ||
        stuff instanceof IRApp_1.IRApp ||
        // stuff instanceof IRConst    ||
        // stuff instanceof IRNative   ||
        stuff instanceof IRLetted_1.IRLetted ||
        stuff instanceof IRHoisted_1.IRHoisted ||
        // stuff instanceof IRError    ||
        stuff instanceof IRForced_1.IRForced ||
        stuff instanceof IRDelayed_1.IRDelayed ||
        stuff instanceof IRConstr_1.IRConstr ||
        stuff instanceof IRCase_1.IRCase);
}
exports.isIRParentTerm = isIRParentTerm;
